import React from "react";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";
import { useTranslation } from "react-i18next";
import { usePropertyStore } from "properties/propertyPage/PropertyContext";
import { getNearestByType } from "properties/propertyPage/propertyViewCollapsible/utils/futureNearbyUtils";

export default function PropertyFutureNearby() {
    const { t } = useTranslation();
    const { property } = usePropertyStore();

    const nearbyList = getNearestByType(property);

    const typeLabels = {
        [ATTRACTION_TYPE.AIRPORT]: t("propertyPage.nearby.type.airport"),
        [ATTRACTION_TYPE.TRAIN_STATION]: t("propertyPage.nearby.type.train_station"),
        [ATTRACTION_TYPE.BUS_STATION]: t("propertyPage.nearby.type.bus_station"),
        [ATTRACTION_TYPE.HOSPITAL]: t("propertyPage.nearby.type.hospital"),
        [ATTRACTION_TYPE.PUBLIC_BEACH]: t("propertyPage.nearby.type.beach_public"),
        [ATTRACTION_TYPE.GROCERY_STORE]: t("propertyPage.nearby.type.grocery_store"),
        [ATTRACTION_TYPE.PHARMACY]: t("propertyPage.nearby.type.pharmacy"),
    };

    return (
        <div className="space-y-4">
            {nearbyList.map(({ type, attraction }) => (
                <div key={type} className="flex justify-between items-center border-b pb-2">
                    <span className="font-medium text-sm">{typeLabels[type]}</span>
                    <div className="text-right">
                        <div className="text-xs md:text-sm font-semibold">{attraction.name}</div>
                        <div className="text-xs md:text-sm text-gray-600">{attraction.distance.toFixed(1)} km</div>
                    </div>
                </div>
            ))}
        </div>
    );
}
